import clsx from 'clsx'
import Image from 'next/image'
import {Partner} from '../../../types/common'
import Box from '../../atoms/box'
import Link from '../../atoms/link'
import Container from '../../atoms/container'
import Heading, {HeadingProps} from '../../atoms/heading'
import Paragraph, {ParagraphProps} from '../../atoms/paragraph'

type PartnerCardProps = {
  partner: Partner
  titleProps?: HeadingProps
  bodyProps?: ParagraphProps
}

function PartnerCard({
  partner,
  titleProps,
  bodyProps,
}: PartnerCardProps) {
  const {logo, name, url, body} = partner
  const {image, width, height, alt} = logo || {}
  const {className: titleClassName, ...restTitleProps} = titleProps || {}
  const {className: bodyClassName, ...restBodyProps} = bodyProps || {}

  return (
    <Link
      className="group"
      fontWeight="normal"
      disableActiveState
      href={url}
      target={url.indexOf('http') == 0 ? '_blank' : ''}
    >
      <Container className="max-w-md  md:px-0">
        <Box className="mx-auto aspect-ratio-16-9 flex items-center rounded-3xl justify-center bg-gradient-to-r from-primary to-primary-extra-light">
          <div className="mx-8">
            {logo && (
              <Image
                src={image}
                alt={alt}
                width={width}
                height={height}
                quality={100}
              />
            )}
          </div>
        </Box>
        <Heading
          variant="h3"
          className={clsx(
            'pt-3 pb-1 transition-colors group-hover:text-primary group-active:text-primary',
            titleClassName,
          )}
          {...restTitleProps}
        >
          {name}
        </Heading>
        <Paragraph
          className={clsx(
            'transition-colors group-hover:text-primary group-active:text-primary',
            bodyClassName,
          )}
          {...restBodyProps}
        >
          {body}
        </Paragraph>
      </Container>
    </Link>
  )
}

export default PartnerCard
